import { render, staticRenderFns } from "./AgeGraph.vue?vue&type=template&id=02074f79&scoped=true"
import script from "./AgeGraph.vue?vue&type=script&lang=js"
export * from "./AgeGraph.vue?vue&type=script&lang=js"
import style0 from "./AgeGraph.vue?vue&type=style&index=0&id=02074f79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02074f79",
  null
  
)

export default component.exports